import 'App.scss';
import 'bootstrap/dist/css/bootstrap.css';
import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router';
import Navbar from 'components/common/Navbar';
import MainPage from 'pages/MainPage';
import CompanyPage from 'pages/CompanyPage';
import BusinessPage from 'pages/BusinessPage';
import ResearchPage from 'pages/ResearchPage';
import ContactPage from 'pages/ContactPage';
import NotFound from 'components/etc/NotFound';
import Footer from 'components/common/Footer';
import { useSelector, useDispatch } from 'react-redux';
import { moreThan768Actions } from 'store/slices/moreThan768Slice';
import { loadingActions } from 'store/slices/loadingSlice';
import LoadingPage from 'pages/LoadingPage';

function App() {

  const [activateMobileMenu, setActivateMobileMenu] = useState(false); // 모바일 메뉴
  const [scrollPosition, setScrollPosition] = useState(0);   // 스크롤 효과

  const dispatch = useDispatch();
  const moreThan768 = useSelector((state) => state.moreThan768.value);
  const loading = useSelector((state) => state.loading.value);

  const updateScroll = () => {
    setScrollPosition(window.scrollY || document.documentElement.scrollTop);
  };

  useEffect(() => {
    dispatch(loadingActions.loading());
    setTimeout(() => dispatch(loadingActions.loaded()), 4500);
    window.addEventListener("scroll", updateScroll);
  }, []);

  useEffect(() => {
    const handleMoreThan768 = () => {
      const winSize = window.innerWidth;
      if (winSize >= 768) {
        dispatch(moreThan768Actions.moreThan768());
        setActivateMobileMenu(true);
      } else {
        dispatch(moreThan768Actions.lessThan768());
        setActivateMobileMenu(false);
      }
    }

    window.addEventListener('resize', handleMoreThan768);
    return () => {
      window.removeEventListener('resize', handleMoreThan768);
    }
  }, [dispatch]);

  return (
    <section className='App'>
      {loading ? <LoadingPage /> : (
        <>
          <Navbar moreThan768={moreThan768} activateMobileMenu={activateMobileMenu} setActivateMobileMenu={setActivateMobileMenu} />
          <Routes>
            <Route path='/' element={<MainPage moreThan768={moreThan768} />} />
            <Route path='/company' element={<CompanyPage scrollPosition={scrollPosition} />} />
            <Route path='/company/:tab' element={<CompanyPage scrollPosition={scrollPosition} />} />
            <Route path='/business' element={<BusinessPage />} />
            <Route path='/business/:tab' element={<BusinessPage />} />
            <Route path='/research' element={<ResearchPage />} />
            <Route path='/research/:tab' element={<ResearchPage />} />
            <Route path='/contact' element={<ContactPage />} />
            <Route path='*' element={<NotFound />} />
          </Routes>
          <Footer />
        </>
      )}
    </section>
  );
}

export default React.memo(App);
